module.exports = __webpack_public_path__ + "6a8b6823f15edd1481fc470571655c5d.pdf";